import { getByPath } from "../store/action";
export const directSave = (dispatch, type, payload, keyName, keyTarget) => {
  dispatch({ type, payload, keyName, keyTarget });
};
export const fetchData = (
  dispatch,
  path,
  data,
  name,
  method,
  keyName,
  toast,
  extra
) => {
  dispatch(getByPath(path, data, name, method, keyName, toast, extra));
};

export const toastBoth = {
  // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  success: {
    type: "success",
    title: "Success",
    description: "Successfully Data Added",
    position: "top-center",
  },
  error: {
    type: "error",
    title: "Error",
    description: "apiMsg",
    position: "top-center",
  },
};
export const getToast = (type, title, description, position) => {
  const toast = JSON.parse(JSON.stringify(toastBoth));
  if (!type) return toast;
  let finalToast = {
    [type]: toast[type],
  };
  if (title) {
    finalToast[type].title = title;
  }
  if (description) {
    finalToast[type].description = description;
  }
  if (position) {
    finalToast[type].position = position;
  }
  return finalToast;
};

export const checkEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export const deID = () => {
  var n = window.navigator;
  var s = window.screen;
  var t = window.performance.memory;
  var deID = n.mimeTypes.length;
  deID += n.userAgent.replace(/\D+/g, "");
  deID += n.plugins.length;
  deID += n.languages.length;
  deID += s.height || "";
  deID += s.width || "";
  deID += s.pixelDepth || "";
  deID += t?.jsHeapSizeLimit || "";
  return deID;
};

//Security Point
// for axios header and save in user table and remove role last charator
// let text = values.email;
// let letter = text.charAt(0);
// const alphaVal = (s) => s.toLowerCase().charCodeAt(0) - 97 + 1;
// console.log(alphaVal(letter));
// console.log(parseInt((alphaVal(letter) + "").charAt(0)));
